{ COCHRANE_ORGANIZATION_ID } = require 'lib/archie_helper'
{ CADTH_EXTRACTORS_ORG_ID } = require 'lib/key_messages_helper'
CustomRenderMixin = require 'components/mixins/custom_render_mixin'
ImportJSONQuestionsDialog = require 'components/import_dialog/import_json_questions_dialog'
mediator = require 'mediator'
Tooltip = require 'components/common/tooltip'
Translation = require 'components/mixins/translation'

ComparisonQuestionsListButtonsRow = createReactClass
  displayName: "ComparisonQuestionsListButtonsRow"

  mixins: [
    CustomRenderMixin
    Translation('es:question')
  ]

  getInitialState: ->
    isImportJsonQuestionsOpen: false

  propTypes:
    handleButtonAction: PropTypes.func.isRequired

  onImportJsonQuestionsClose: ->
    @setState isImportJsonQuestionsOpen: false

  onImportJsonQuestionsOpen: ->
    @setState isImportJsonQuestionsOpen: true

  onButtonClick: (action) -> =>
    { handleButtonAction } = @props
    if action is 'import-json-questions'
      @onImportJsonQuestionsOpen()
    else
      handleButtonAction(action)()

  getButtons: ->
    activeWorkspace = mediator.activeWorkspace
    gpsFeatureOn = mediator.services.switches.isServerSwitchOn('gps') or mediator.services.switches.isOn('gps')
    cadthFeaturesOn = mediator.services.switches.isServerSwitchOn('cadthFeatures')
    overarchingQuestionsFeatureOn = mediator.services.switches.isOn('overarching-questions')
    isCADTHExtractorWorkspace = activeWorkspace is CADTH_EXTRACTORS_ORG_ID
    importQuestionsFromJsonFeatureOn = mediator.services.switches.isOn('importQuestionsFromJson')

    BUTTONS =
      'add-management-question':
        label: "add_title"
        visible: not isCADTHExtractorWorkspace
      'add-diagnostic-question':
        label: "add_diagnostic_title"
        visible: not isCADTHExtractorWorkspace
      'add-good-practice-question':
        label: "add_good_practice_title"
        visible: gpsFeatureOn and not isCADTHExtractorWorkspace
      'add-key-message':
        label: "add_key_message_title"
        visible: cadthFeaturesOn
      'add-overarching-question':
        label: "/actions.create_overarching_question"
        visible: overarchingQuestionsFeatureOn and not isCADTHExtractorWorkspace
      'import-json-questions':
        label: "/projects:import_json_questions_dialog.import_json_questions_button"
        visible: importQuestionsFromJsonFeatureOn
      'import-questions':
        label: "/import.questions"
        visible: not isCADTHExtractorWorkspace
        tooltip: '/import.questions_title'
        disabled: activeWorkspace is COCHRANE_ORGANIZATION_ID

    _.reduce BUTTONS, (acc, buttonProps, buttonKey) =>
      if buttonProps.visible
        acc.push <Tooltip key={buttonKey}>
          <button
            className="btn btn-block"
            title={if buttonProps.tooltip then @i18n(buttonProps.tooltip) else null}
            onClick={@onButtonClick(buttonKey)}
            disabled={buttonProps.disabled or false}
          >
            {@i18n buttonProps.label}
          </button>
        </Tooltip>
      acc
    , []

  render: ->
    <div className='create-questions-container'>
      {@getButtons()}
      <ImportJSONQuestionsDialog
        isOpen={@state.isImportJsonQuestionsOpen}
        onClose={@onImportJsonQuestionsClose}
      />
    </div>

module.exports = ComparisonQuestionsListButtonsRow
